<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <button
        class="navbar-toggler navbar-burger"
        type="button"
        @click="toggleSidebar"
        :aria-expanded="$sidebar.showSidebar"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item" v-if="showProdPush">
            <button
              class="nav-link"
              :class="{ 'icon-present': isPushing || isPushed }"
              @click="pushToProd()"
            >
              Push to Production <span>{{ pushIndicator }}</span>
            </button>
          </li>
          <li class="nav-item" v-if="currentUser">
            <a
              href="https://docs.sensoreal.app/"
              class="nav-link navbar-account-link navbar-account-link--support"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i class="ti-headphone"></i>
              <span>Support</span>
            </a>
          </li>
          <li class="nav-item" v-if="currentUser">
            <router-link
              :to="`/users/update/${currentUser.id}`"
              class="nav-link navbar-account-link"
            >
              <i class="ti-user"></i>
              <span>{{ currentUser.email }}</span>
            </router-link>
          </li>
          <li class="nav-item">
            <a
              href="#"
              class="nav-link navbar-account-link"
              @click.prevent="logout()"
            >
              <i class="ti-power-off"></i>
              <span>Logout</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
import { mapGetters } from "vuex";
import { LOGOUT } from "@/store/actions.type";

export default {
  computed: {
    ...mapGetters(["currentUser", "isAuthenticated", "isPushed", "isPushing"]),

    showProdPush() {
      const hasAccess = this.currentUser.access.includes("push-production");

      return process.env.VUE_APP_ENABLE_PROD_PUSH === "true" && hasAccess;
    },

    pushIndicator() {
      if (this.isPushing) return "⏳";
      if (this.isPushed) return "✅";
      return "";
    },

    routeName() {
      const { name } = this.$route;
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },

  methods: {
    pushToProd() {
      this.$store.dispatch("PUSH_TO_PROD");
    },

    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    logout() {
      this.$store.dispatch(LOGOUT).then(() => {
        this.$router.push({ name: "login" });
      });
    }
  }
};
</script>
<style lang="scss">
.nav-link {
  span {
    display: none;
  }

  &.icon-present {
    span {
      display: inline-block;
      padding-left: 10px;
    }
  }
}

.navbar-account-link {
  display: inline-flex;
  align-items: center;
  color: #66615b;
  font-weight: 400;

  i,
  span {
    display: inline-block;
  }

  &:hover,
  &:focus {
    color: #403d39;
    text-decoration: none;
  }
}

.navbar .navbar-nav .nav-item .nav-link.navbar-account-link i {
  top: 2px;
  right: 0;
  margin-right: 8px;
}

.navbar .navbar-nav .nav-item .nav-link.navbar-account-link--support {
  margin-left: 16px;
}
</style>
